import fetchService from '@xanadu/ui-shared/utils/fetchService';

const useRgInteractionAck = async (rgSelection) => {
  try {
    await fetchService('/bpapi/rest/responsible-gambling/interaction/ack', {
      method: 'POST',
      body: JSON.stringify({
        'chosen-option': rgSelection,
      })
    }, { camelizeKeys: false });
  } catch (err) {
    const errorMessage = 'Error sending RG interaction acknowledgement';
    // eslint-disable-next-line no-console
    console.warn(errorMessage, err);
  }
};

export default useRgInteractionAck;
